<template>
    <div>
        <vx-card title="Add New Collection" code-toggler>
            <vx-input-group class="mb-6">
                <template slot="prepend">
                    <div class="prepend-text bg-dark">
                        <span>Arabic Name</span>
                    </div>
                </template>

                <vs-input v-model="ar_name" />
            </vx-input-group>
            <vx-input-group class="mb-6">
                <template slot="prepend">
                    <div class="prepend-text bg-dark">
                        <span>English Name</span>
                    </div>
                </template>

                <vs-input v-model="en_name" />
            </vx-input-group>
            <vx-input-group class="mb-6">
                <template slot="prepend">
                    <div class="prepend-text bg-dark">
                        <span>Poster</span>
                    </div>
                </template>

                <input type="file" ref="poster" @change="handleFilePoster" />
            </vx-input-group>

            <vx-input-group class="mb-6">
                <template slot="prepend">
                    <div class="prepend-text bg-dark">
                        <span>Cover</span>
                    </div>
                </template>

                <input type="file" ref="cover" @change="handleFileCover" />
            </vx-input-group>

            <div class="vx-row">
                <div class="vx-col w-full">
                    <vs-button flat class="mr-3 mb-2 mt-3" @click="save">Submit</vs-button>
                    <vs-button to="/stories" color='secondary' flat class="mr-3 mb-2 mt-3" @click="save">Submit
                    </vs-button>
                </div>
            </div>

        </vx-card>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                ar_name: '',
                en_name: '',
                poster: '',
                cover: ''
            }
        },
        methods: {
            save() {
                const data = new FormData();
                data.append('ar_name', this.ar_name);
                data.append('en_name', this.en_name);
                data.append('poster', this.poster);
                data.append('cover', this.cover);
                this.axios.post(`${this.$apiUrl}/collections`, data, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(res => {
                    if (res.status == 200) {
                        this.$router.push({name:'collections'})
                        this.$vs.notify({
                            color: 'success',
                            title: 'Collection Addedd',
                            text: ''
                        })
                    }
                });
            },
            handleFilePoster() {
                this.poster = this.$refs.poster.files[0];
            },
            handleFileCover() {
                this.cover = this.$refs.cover.files[0];
            }
        },
    }
</script>